export var ACTIVATE_BUTTONS = [
    // 'Space',
    // ' ',
    'Enter',
];
export var UP_BUTTONS = ['ArrowUp', 38];
export var SPACE_BUTTON = ['Space', ' '];
export var DOWN_BUTTONS = ['ArrowDown', 40];
export var CLOSE_BUTTONS = ['Enter', 'Escape', 'Esc'];
export var DIRECTION_ARROWS = ['ArrowLeft', 'ArrowRight'];
